import styled from "styled-components";

import ratingIcon from "../../assets/ratingIcon.svg";
import ratingIconFilled from "../../assets/ratingIconFilled.svg";

const TourRatingWrapper = styled.div`
  border-top: 1px solid #e6e6e6;
  margin-top: 3px;
  padding: 8px 0 5px;
  fieldset {
    border: none;
    padding-bottom: 0;
    padding-left: 0;
  }
`;

const RatingIconWrapper = styled.div`
  background: url("${ratingIcon}");
  background-size: 32px 24px;
  height: 24px;
  margin-left: -4px;
  position: relative;
  width: 160px;
  label {
    background-size: 24px 24px;
    height: 100%;
    position: absolute;
  }

  label:first-of-type {
    width: 20%;
    z-index: 5;
  }
  input:first-of-type {
    left: 4px;
  }

  label:nth-of-type(2) {
    width: 40%;
    z-index: 4
  }
  input:nth-of-type(2) {
    left: 36px;
  }

  label:nth-of-type(3) {
    width: 60%;
    z-index: 3
  }
  input:nth-of-type(3) {
    left: 68px;
  }

  label:nth-of-type(4) {
    width: 80%;
    z-index: 2
  }
  input:nth-of-type(4) {
    left: 100px;
  }

  label:last-of-type {
   width: 100%;
   z-index: 1
  }
  input:last-of-type {
    left: 132px;
  }

  input:focus + label {
    outline: auto;
  }

  input:checked + label {
    background: url("${ratingIconFilled}");
  }

  input:focus ~ label {
    background: url("${ratingIcon}");
  }

  input:focus + label,
  &:hover label {
    background: url("${ratingIconFilled}");
    cursor: pointer;
  }

  label:hover ~ label {
    background: url("${ratingIcon}")
  }
`;

export { RatingIconWrapper, TourRatingWrapper };
